
    // Declare APP_COMMIT as a global variable in app for version checks using the commit hash
    window.APP_COMMIT = "35b6a90";
  